/* eslint-env browser, jquery */

'use strict';

const ProductBundles =
  window.ProductBundles != null
    ? window.ProductBundles
    : (window.ProductBundles = {});

if (ProductBundles.Views == null) {
  ProductBundles.Views = {};
}

ProductBundles.Views.BundleModal = require('./product_bundle_modal');

// Creating only one instance of the modal to prevent Ghost Views issue
ProductBundles.Views.modal = new ProductBundles.Views.BundleModal();

ProductBundles.Views.Bundle = window.Backbone.View.extend({
  events: {
    'click .product-bundles-item-title': 'openModalDesktop',
    'click .more-details': 'openModalTouch',
    'change .product-bundles-option': 'toggleBundleOption',
  },
  initialize({ model, bundle, bundlesTitle, isTouch }) {
    this.model = model;
    this.productBundle = bundle;
    this.bundlesTitle = bundlesTitle;
    this.isTouch = isTouch;
    this.template = isTouch
      ? require('../../responsive/item.html.mustache')
      : require('../../item.html.mustache');
    this.modalView = ProductBundles.Views.modal;
    this.modalView.setIsTouch(isTouch);
    $('.goods-warranty-option').change(this.goodsWarrantyChanged.bind(this));
    return this.listenTo(
      this.model,
      'change:isSelected',
      this.updateAddonCheckboxState
    );
  },
  updateModalView() {
    this.modalView.model = this.model;
    this.modalView.updateProductBundle({
      bundle: this.productBundle,
      bundlesTitle: this.bundlesTitle,
    });
  },
  openModalDesktop() {
    this.updateModalView();
    return window.GIG.Modal.open({
      el: $('#product-bundles-modal'),
    });
  },
  openModalTouch() {
    this.updateModalView();
    this.$body = this.$body || $('body');
    this.$htmlbody = this.$htmlbody || $('html,body');
    this.$mainTouchPane = this.$mainTouchPane || $('#global-container');
    this.modalView.scrollOffset = this.$htmlbody.scrollTop();
    this.$mainTouchPane.hide();
    this.modalView.$el.show();
    this.$htmlbody.animate({ scrollTop: 0 }, 'slow');
  },
  updateAddonCheckboxState() {
    if (this.$productBundleCheckbox == null) {
      this.$productBundleCheckbox = $(
        `#product-bundles-option-${this.productBundle.uuid}`
      );
    }
    this.updateItemInCart();
    if (this.$productBundleCheckbox.length) {
      // Uncheck warranty option if it exists, as they can't be together in cart
      if (this.model.get('isSelected')) {
        $('.goods-warranty-option')
          .prop('checked', false)
          .change();
      }
      return this.$productBundleCheckbox.prop(
        'checked',
        this.model.get('isSelected')
      );
    } else {
      return null;
    }
  },
  toggleBundleOption() {
    if (this.$productBundleCheckbox == null) {
      this.$productBundleCheckbox = $(
        `#product-bundles-option-${this.productBundle.uuid}`
      );
    }
    if (this.$productBundleCheckbox.length) {
      return this.model.set(
        'isSelected',
        this.$productBundleCheckbox.is(':checked')
      );
    } else {
      return null;
    }
  },
  goodsWarrantyChanged(event) {
    // Deselecting product bundle if warranty bundle is selected.
    if (event.target.checked) {
      this.model.set('isSelected', false);
    }
  },
  updateItemInCart() {
    const { dealUuid, uuid } = this.productBundle;
    const shouldRemove = !this.model.get('isSelected');
    // Listened in parent product_bundles View
    this.trigger('update-item-in-cart', { dealUuid, uuid, shouldRemove });
  },
  render() {
    return this.$el.append(
      this.template.render({
        bundle: this.productBundle,
      })
    );
  },
});

module.exports = ProductBundles.Views.Bundle;
